import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import { Hidden } from './Hidden'
import style from './LoadingComparator.module.sass'

export const LoadingComparator: FunctionComponent = () => {
	const times = 3

	return (
		<div className={style.loadingPreviewWrapper}>
			{[...Array(times)].map((elem, index) => (
				<div key={index} className={clsx(style.cardWrapper, style.cardWrapperLoading)}>
					<div className={style.loadingPreview} />
				</div>
			))}
			<Hidden breakpoint="mobileDown">
				<div className={clsx(style.loadingPreviewDotWrapper)}>
					{[...Array(times)].map((elem, index) => (
						<div key={index} className={clsx(style.cardWrapper, style.cardWrapperLoading)}>
							<div className={clsx(style.loadingPreview, style.loadingPreviewDots)} />
						</div>
					))}
				</div>
			</Hidden>
		</div>
	)
}
